import { withLoading, MarkdownRenderer, useAppContext } from '@front-activerse/common-components';
import { Helmet } from 'react-helmet';
import Layout from '../Layout/Layout';
import { Container, Row, Col } from 'reactstrap';
import UniversalPlaceholder from '../Layout/UniversalPlaceholder';
import TitleBar from '../Layout/TitleBar';
import { useLocation } from 'react-router-dom';

const Content = ({ content }) => {
  const location = useLocation();

  console.log('content', content);

  const {
    consts: { APP_VERSION },
  } = useAppContext();

  let userEmail = 'undefined';
  const apolloCachePersist = JSON.parse(localStorage.getItem('apollo-cache-persist'));
  console.log('apolloCachePersist', apolloCachePersist);
  if (apolloCachePersist) {
    userEmail = apolloCachePersist[Object.keys(apolloCachePersist)[0]].email;
    console.log('userEmail', userEmail);
  }
  return (
    <Layout simpleLayout>
      <Helmet>
        <title>{content.title}</title>
        <meta name="description" content="" />
        <meta name="robots" content="noindex,nofollow" />
      </Helmet>
      <TitleBar showBackBtn={false}>{content.title}</TitleBar>
      <div className="page-template-content full-height7">
        <Container className="py-md-4">
          <Row>
            <Col xl={{ size: 10, offset: 1 }}>
              <div className="page-container">
                <div className="content-container">
                  <div className="cms-content">
                    {/* hack for too long privacy policy in shestrong sv-SE (markdown renderer crashed browsers) */}
                    {location.pathname === '/privacy-policy' ? (
                      <div dangerouslySetInnerHTML={{ __html: content.content.html }} />
                    ) : (
                      content.content && <MarkdownRenderer content={content.content.markdown} />
                    )}
                  </div>
                  {location.pathname === '/info' ? (
                    <>
                      <hr />
                      <p>React app version: {APP_VERSION}</p>
                      <hr />
                      <p>User token: {localStorage.getItem('token')}</p>
                      <hr />
                      <p>User: {userEmail}</p>
                    </>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </Layout>
  );
};

const Placeholder = () => <UniversalPlaceholder simpleLayout fullHeightMinusHeader />;

export default withLoading(Content, Placeholder);
